<template>
<span class="badge badge-light" v-popover="`Your detected time zone: ${timezone}`">{{ utc_offset_string }}</span>
</template>
<script lang="js">
import { Utils } from '@/helpers/utils';

export default{
    data(){
        return {
            timezone: Utils.get_local_timezone(),
            utc_offset_string: Utils.get_utc_offset_string()
        }
    }
}
</script>